import {
    leftColumn,
    leftColumnRtl,
    leftColumnDenseless,
    leftColumnDenselessRtl,
    leftColumnNoTopMargin,
    leftColumnBleedThrough,
    newBackgroundOpacity,
} from './MailModule.scss';
import classnames from 'owa-classnames';
import { getShouldShowStorageNotification } from '../utils/getShouldShowStorageNotification';
import { observer } from 'owa-mobx-react';
import { getCurrentCulture, isCurrentCultureRightToLeft } from 'owa-localize';
import { FolderPane } from 'owa-mail-folder-forest-view';
import { LeftnavStorageNotification } from 'owa-mail-leftnav-storage-notification';
import { LeftnavUpsell } from 'owa-mail-leftnavupsell';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getNativeadsUpsellEffectStore } from 'owa-nativeadsupselleffect-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { lazyGetStorageStore } from 'owa-storage-store';
import { LazyLeftNavStorageBar } from 'owa-storage-quota';
import { IsChildConsumerUser, IsShadowMailboxUser } from 'owa-mail-ads-shared';
import { isCapabilityEnabled } from 'owa-capabilities';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { bleedThroughCapability } from 'owa-capabilities-definitions/lib/bleedThroughCapability';
import { isServiceRequestSupportedForMailbox } from 'owa-service/lib/utils/isServiceRequestSupportedForMailbox';
import { shouldShowFolderPaneAsTransientOverlay } from 'owa-mail-layout';
import type { FunctionComponent } from 'react';

const defaultExport: FunctionComponent<{}> = observer(function FolderPaneContainer() {
    const mailboxInfo = getModuleContextMailboxInfo();
    /* eslint-disable-next-line no-restricted-properties -- (https://aka.ms/OWALintWiki)
     * BASELINE. Do not copy and paste!
     *	> 'tryImportForRender' is restricted from being used. tryImportForRender should only be used in rare circumstances and can hurt TTI if used incorrectly. */
    const getStorageStore = lazyGetStorageStore.tryImportForRender();
    const usagePercentage = getStorageStore?.(mailboxInfo).emailStorage.usagePercentage ?? 0;
    const isNewStorageUIEnabled: boolean = isConsumer(undefined, mailboxInfo);

    const isRPDenselessEnabled = isGlobalFeatureEnabled('mon-type-ramp');

    // Value deciding whether to show the storage notification
    const showStorageNotification: boolean =
        !IsShadowMailboxUser(mailboxInfo) &&
        getShouldShowStorageNotification(getStorageStore?.(mailboxInfo), mailboxInfo);

    const showLeftNavPremiumUpsell =
        isServiceRequestSupportedForMailbox(mailboxInfo) &&
        isConsumer(undefined, mailboxInfo) &&
        !IsShadowMailboxUser(mailboxInfo) &&
        !IsChildConsumerUser(mailboxInfo) &&
        getCurrentCulture().indexOf('jp') === -1 &&
        !showStorageNotification &&
        !getNativeadsUpsellEffectStore().isEffective;

    const isBleedThroughEnabled = isCapabilityEnabled(bleedThroughCapability);
    const isRTL = isCurrentCultureRightToLeft();
    const showTransientOverlayPane = shouldShowFolderPaneAsTransientOverlay();
    const customClassNames = classnames(
        isRPDenselessEnabled ? leftColumnDenseless : leftColumn,
        showTransientOverlayPane && leftColumnNoTopMargin,
        isRTL && (isRPDenselessEnabled ? leftColumnDenselessRtl : leftColumnRtl),
        isBleedThroughEnabled && leftColumnBleedThrough,
        isBleedThroughEnabled && isRPDenselessEnabled && newBackgroundOpacity
    );

    return (
        <div className={customClassNames}>
            <FolderPane />
            {showStorageNotification && !isNewStorageUIEnabled && (
                <LeftnavStorageNotification
                    mailboxInfo={mailboxInfo}
                    usagePercentage={usagePercentage}
                />
            )}

            {showStorageNotification && isNewStorageUIEnabled && getStorageStore?.(mailboxInfo) && (
                <LazyLeftNavStorageBar
                    mailboxInfo={mailboxInfo}
                    storageInfos={getStorageStore?.(mailboxInfo)}
                />
            )}
            {showLeftNavPremiumUpsell && <LeftnavUpsell mailboxInfo={mailboxInfo} />}
        </div>
    );
}, 'FolderPaneContainer');
export default defaultExport;
